export function handleUserColor(name) {
    var sanitized = name.replace(/[^A-Za-z]/, '');
    var letters = sanitized.split('');

    //Determine the hue
    var hue = Math.floor((letters[0].toLowerCase().charCodeAt() - 96) / 26 * 360);
    var ord = '';
    for (var i in letters) {
        ord = letters[i].charCodeAt();
        if ((ord >= 65 && ord <= 90) || (ord >= 97 && ord <= 122)) {
            hue += ord - 64;
        }
    }

    hue = hue % 360;

    //Determine the saturation
    var vowels = ['A', 'a', 'E', 'e', 'I', 'i', 'O', 'o', 'U', 'u'];
    var count_cons = 0;

    //Count the consonants
    for (i in letters) {
        if (vowels.indexOf(letters[i]) === -1) {
            count_cons++;
        }
    }

    //Determine what percentage of the string is consonants and weight to 95% being fully saturated.
    var saturation = count_cons / letters.length / 0.95 * 100;
    if (saturation > 100) saturation = 100;

    //Determine the luminosity
    var ascenders = ['t', 'd', 'b', 'l', 'f', 'h', 'k'];
    var descenders = ['q', 'y', 'p', 'g', 'j'];
    var luminosity = 50;
    var increment = 1 / letters.length * 50;

    for (i in letters) {
        if (ascenders.indexOf(letters[i]) !== -1) {
            luminosity += increment;
        } else if (descenders.indexOf(letters[i]) !== -1) {
            luminosity -= increment * 2;
        }
    }
    if (luminosity > 100) luminosity = 100;

    var conventColor = hslToRgb(hue, saturation, luminosity);
    return conventColor;
}

export function hslToRgb(h, s, l) {
    // Must be fractions of 1
    s /= 100;
    l /= 100;

    let c = (1 - Math.abs(2 * l - 1)) * s,
        x = c * (1 - Math.abs((h / 60) % 2 - 1)),
        m = l - c / 2,
        r = 0,
        g = 0,
        b = 0;

    if (0 <= h && h < 60) {
        r = c; g = x; b = 0;
    } else if (60 <= h && h < 120) {
        r = x; g = c; b = 0;
    } else if (120 <= h && h < 180) {
        r = 0; g = c; b = x;
    } else if (180 <= h && h < 240) {
        r = 0; g = x; b = c;
    } else if (240 <= h && h < 300) {
        r = x; g = 0; b = c;
    } else if (300 <= h && h < 360) {
        r = c; g = 0; b = x;
    }
    r = Math.round((r + m) * 255);
    g = Math.round((g + m) * 255);
    b = Math.round((b + m) * 255);

    return "rgb(" + r + "," + g + "," + b + ")";
}